import { useEffect } from 'react';
import type { AuthStatus } from './authStatus';
import { FirebaseAuthenticationClient } from '../firebase/auth/FirebaseAuthenticationClient';
import { CookieUtils } from '../CookieUtils';

const IDTokenCookieKey = 'Balus-ID-Token';

type Props = {
  authStatus: AuthStatus;
};

export const IdTokenSyncToCookie: React.FC<Props> = ({ authStatus }: Props) => {
  // ログイン中のユーザID, セッションIDが変化した際には、強制的に IdToken をリフレッシュする
  useEffect(() => {
    const forceRefresh = true;
    FirebaseAuthenticationClient.getIdTokenResult(forceRefresh).then((tokenResult) => {
      if (!tokenResult) {
        CookieUtils.set(IDTokenCookieKey, '', { expires: 0 });
        return;
      }

      const { token, expirationTime } = tokenResult;
      CookieUtils.set(IDTokenCookieKey, token, { expires: new Date(expirationTime) });
    });
  }, [authStatus]);

  // Firebase Auth の保持する IDトークン (JWT) の更新を監視し、IDトークンが更新された時にCookieにもその値を設定する
  useEffect(() => {
    const unsubscribe = FirebaseAuthenticationClient.onIdTokenChanged((user) => {
      if (!user) {
        CookieUtils.set(IDTokenCookieKey, '', { expires: 0 });
        return;
      }

      // IdTokenをCookieに設定する (Cookieの有効期限と、IdTokenの有効期限を揃える)
      user.getIdTokenResult().then((tokenResult) => {
        const { token, expirationTime } = tokenResult;
        CookieUtils.set(IDTokenCookieKey, token, { expires: new Date(expirationTime) });
      });
    });

    return () => unsubscribe();
  }, []);

  return <></>;
};
